import { getFormatKeySync } from 'frontend/common/date-format/get-format-key-sync'

function resolveNulls(a, b) {
  if (a === null && b === null) {
    return 0
  }
  if (a === null) return 1
  if (b === null) return -1
  return null
}

function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    const v = key instanceof Function ? key(x) : x[key]
    ;(rv[v] = rv[v] || []).push(x)
    return rv
  }, {})
}

function formatTimestamp(date, timeZone) {
  let formattedTimestamp
  date = dayjs(date).tz(timeZone)

  if (isCurrentDay(date, timeZone)) {
    formattedTimestamp = date.format(getFormatKeySync('chatToday'))
  } else if (isCurrentWeek(date, timeZone)) {
    formattedTimestamp = date.format(getFormatKeySync('chatWeek'))
  } else {
    formattedTimestamp = date.format(getFormatKeySync('chatFull'))
  }
  return formattedTimestamp
}

function isCurrentDay(date, timeZone) {
  return date.isSame(dayjs().tz(timeZone), 'day')
}

function isCurrentWeek(date, timeZone) {
  return date.isSame(dayjs().tz(timeZone), 'week')
}

function generateColor(string) {
  string = string.replace(/\s/g, '')
  const charCodeSum = sumCharCodes(string)
  const hue = introducePredictableChaos(charCodeSum)
  const modifyBy = string.charCodeAt(0) % 11
  const signSaturation = charCodeSum % 2 === 0 ? -1 : 1
  const signLightness = string.charCodeAt(0) % 2 === 0 ? -1 : 1

  return `hsl(${hue % 360}, ${50 + modifyBy * signSaturation}%, ${60 + modifyBy * signLightness}%)`
}

function introducePredictableChaos(x) {
  //Using a chaotic sine function that quickly diverges for similar values
  return Math.abs(13 * Math.sin((x / 10) % 360)) * 666.6
}

function sumCharCodes(string) {
  let sum = 0
  for (let i = 0; i < string.length; i++) {
    let value = string.charCodeAt(i)
    sum += value *= 13
  }
  return sum || Math.random() * 360
}

export { formatTimestamp, generateColor, groupBy, resolveNulls }
